/* eslint-disable no-console */
import { AmeyoIcon } from '@cp/assets/icons/AmeyoIcon';
import styles from './AmeyoCollapsibleToolbar.module.scss';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Typography } from '@primitives';
import CloseIcon from '../../assets/icons/CloseIcon';
import { RssIcon } from '@cp/assets/icons/RssIcon';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import CyclicArrow from '../../assets/icons/CyclicArrow';
import useOutsideClick from '@hooks/useOutsideClick';
import {
  EXTENSION_LISTENER_TYPES,
  ExtensionHandler,
  ExtensionHelper
} from '@cp/utils/extension.utils';
import {
  AMEYO_CALL_EVENTS,
  AMEYO_STATUS_CODES,
  AMEYO_STATUS_RANKS,
  AmeyoCallData,
  IAmeyoRecalibratedData
} from '../../service/naviExtension.service';
import Switch from '@primitives/Switch';
import { AllCasesSummary } from '@cp/pages/Cases/constants/CasesInterfaces';
import { getCustomerDetails } from '@cp/pages/CaseDetails/actions/casesDetailsActions';
import { getCustomerReferenceIdFromLAN, getTelephones } from './ameyoActions';
import { ITelePhoneData } from '@cp/pages/CaseDetails/interfaces/CaseDetail.type';
import axiosInstance, { ApiKeys, getApiUrl } from '../../utils/ApiHelper';
import {
  CreateInteractionRequest,
  IConnectedCustomer,
  onToggleAmeyoStatusDataProps,
  PhoneNumberSources
} from './interfaces';
import {
  CALLING_MODES,
  ECallingType,
  InteractionType
} from '@cp/pages/CaseDetails/feedbackForm/interfaces/index.type';
import { CosmosSyncBlockStatus, setAmeyoCallDetails } from '@cp/reducers/commonSlice';
import { toast } from '@primitives/Toast';
import { createQueryParams } from '@cp/utils/QueryParamsHelper';
import { handleTabClose, isFunction, navigateToCaseDetails } from '@cp/utils/commonUtils';
import APP_ROUTES from '../../layout/Routes';
import { useNavigate } from 'react-router-dom';
import GridRow from '@navi/web-ui/lib/layouts/Grid/GridRow/GridRow';
import GridColumn from '@navi/web-ui/lib/layouts/Grid/GridColumn/GridColumn';
import cx from 'classnames';
import { addClickstreamEvent } from '../../service/clickStreamEventService';
import { AMEYO_SESSION_EVENTS, CLICKSTREAM_EVENT_NAMES } from '../../service/clickStream.constant';
import MuteIcon from 'src/assets/icons/MuteIcon';
import UnMuteIcon from 'src/assets/icons/UnMuteIcon';
import { Tooltip, TooltipContent, TooltipTrigger } from '../TooltipV2/TooltipV2';
import {
  AMEYO_CALL_COUNT_POLLING_INTERVAL,
  AMEYO_MUTE_DISCLAIMER_INTERVAL,
  AmeyoCallState,
  AmeyoConstants,
  AmeyoToggleNewStatus
} from './constants';
import MicOff from 'src/assets/icons/MicOff';
import HangUpCallIcon from 'src/assets/icons/HangUpCallIcon';
import MuteCircledIcon from 'src/assets/icons/MuteCircledIcon';
import UnMuteCircledIcon from 'src/assets/icons/UnMuteCircledIcon';
import { jsxToString } from './utils';
import NaviTabIcon from 'src/assets/icons/NaviTabIcon';
import ErrorIcon from 'src/assets/icons/ErrorIcon';
import { LITMUS_EXPERIMENT_NAMES } from '@cp/src/constants/litmusExperimentNames';
import isLitmusExperimentEnabled from '@cp/src/utils/isLitmusExperimentEnabled';
import { LocalStorage } from '@cp/src/utils/StorageUtils';
import { LOCAL_STORAGE_KEYS } from '@cp/src/constants/StorageKeys';
import {
  resetState,
  setAmeyoCallData,
  setAmeyoExtensionToggleOn,
  setButtonLoadingStates,
  setConnectedCustomerData,
  setCurrentState,
  setIsAmeyoErronous,
  setIsAmeyoExtOffDisclaimerVisible,
  setIsAvailable,
  setIsMuteDisclaimerVisible,
  setIsVisible,
  setNotificationBubbleColor,
  setShouldPlayRingtone,
  setShowAmeyoErroneousMsg,
  setTelephoneSource,
  setToolbarAuthState
} from '@cp/reducers/ameyoSlice';
import { BUBBLE_COLORS, BUTTON_ENABLED_TIMEOUT } from '@cp/constants/ameyoConstants';
import { poll } from '@cp/utils/polling';
import { getCallBridgeData } from '@cp/pages/auth/AuthActions';
import { noop } from '@utils/common';
import KeyValueLabel from '@primitives/KeyValueLabel';
import useCallSdk from '@universal-call-sdk/core/lib/useCallSdk';
import AmeyoAdapter from '@universal-call-sdk/adapter-ameyo/lib/main';
import { StateType } from '@universal-call-sdk/adapter-ameyo/lib/types';
import { BroadcastChannelMessages } from '@cp/components/Ameyo/broadcastChannelMessage';
import { setAmeyoLoggedIn } from '@cp/src/service/ameyo.service';
import { GenericObject } from '@cp/src/types/CommonConstans';
import logger from '@cp/utils/logger';
import { ameyo_errorenous_message, errorenous_break_reason } from '@cp/constants/Common.constants';
import sdkHelper from '@cp/pages/DashboardV3/utils/sdkHelper';
import isNaviAgency from '@cp/utils/isNaviAgency';

type IInteractionData = {
  interactionId: string;
  recipientNumber: string;
  crtObjectId: string;
};

export const AmeyoCollapsibleToolbarV4 = (props: {
  isCallHappening: (isHappening: boolean) => void;
}) => {
  const authData = useSelector((state: RootState) => state.common.userData);
  const ameyoExtensionToggleOn = useSelector(
    (state: RootState) => state.humanReminder?.ameyoExtensionToggleOn
  );
  const campaignId = useSelector((state: RootState) => state?.common?.userData?.campaignId);
  const {
    isAmeyoErronous,
    ameyoCallData,
    toolbarAuthState,
    isVisible,
    telephoneSource,
    notificationBubbleColor,
    shouldPlayRingtone,
    isMuteDisclaimerVisible,
    isAmeyoExtOffDisclaimerVisible,
    buttonLoadingStates,
    connectedCustomerData,
    showAmeyoErroneousMsg,
    currentAmeyoState,
    isAvailable: isAmeyoAvailable
  } = useSelector((state: RootState) => state?.ameyoSlice);
  const ameyoConnectedCallCount = useSelector(
    (state: RootState) =>
      state?.leaderboard?.callbridgeData?.successfulAmeyoAttemptedCount ?? '--'
  );
  const isUserImpersonated = useSelector(
    (store: RootState) => store?.common?.userData.userImpersonated
  );
  const isExternalAmeyoCallingEnabled = useSelector(
    (store: RootState) => store?.common?.featureFlags?.isExternalAmeyoCallingEnabled
  );
  let authError = false;
  const navigate = useNavigate();
  const currentRef = useRef(null);
  const dispatch = useDispatch();
  const toolbarAuthStateRef = useRef(toolbarAuthState);
  toolbarAuthStateRef.current = toolbarAuthState;
  const timerId = useRef<NodeJS.Timeout>();
  const [interactionData, setInteractionData] = useState<IInteractionData | null>(null);
  const [currentAmeyoCallDetails, setCurrentAmeyoCallDetails] = useState<{
    lan: string;
    phoneNumber: string;
    crtObjectId: string;
  }>({ lan: '', phoneNumber: '', crtObjectId: '' });
  const [callCountEnabled, setCallCountEnabled] = useState(false);
  const ameyoCallsCountIntervalRef = useRef<() => void>();

  const ameyoUserName = useMemo(
    () =>
      isExternalAmeyoCallingEnabled ? authData?.ameyoUserName : authData?.email,
    [authData?.ameyoUserName, authData?.email, isExternalAmeyoCallingEnabled]
  );

  const configUrl = window?.config?.AMEYO_TELE_URL;
  const adapterOptions = useMemo(
    () =>
    ({
      baseUrl: `${window.location.origin}/ameyoTele`,
      loginUrl: 'naviapp1.ameyo.net',
      eventListenerUrl: `https://naviapp1.ameyo.net:8443/ameyorestapi/pushes?`,
      userName: ameyoUserName,
      password: authData?.ameyoKey
    } as any),
    [ameyoUserName, authData?.ameyoKey]
  );

  const {
    acceptCall: acceptCallNew,
    rejectCall: rejectCallNew,
    registerOnCallConnected,
    registerOnCallIncoming,
    callState,
    registerOnForcedLogoutListener,
    registerOnAgentAvailabilityChange,
    registerOnLoginFailedListener,
    registerOnCallDisconnected,
    unmuteCall: unmuteCallNew,
    muteCall: muteCallNew,
    initialize,
    registerOnAdapterReady,
    getAgentAvailability,
    setAvailable,
    setOnBreak,
    getLatestCallState,
    logOut
  } = useCallSdk({
    AdapterClass: AmeyoAdapter,
    metricsConfig: {
      metricUrl: '/api/ameyo-stats/publish-diagnostic-data', //this is not needed since we are using custom transporter
      isMetricEnabled: false, // Disabled to avoid Cybertron version compatibility issues - using custom metricTransporter instead
      metricFlowName: 'TELE',
      metricTransporter: (metricData: GenericObject) => {
        const metricApi = getApiUrl(ApiKeys.PUBLISH_METRICS_TO_GRAPHANA);
        if (!isUserImpersonated) {
          axiosInstance.post(
            metricApi,
            {
              campaignId: '0', //we are sending the filler campaign id since its not handled in BE can be removed in future
              ...metricData
            },
            { headers: { donotHandleError: true } }
          );
        }
      }
    },
    clickStreamConfig: {
      clickStreamTransporter: (payload: GenericObject) => {
        logger({
          msg: 'universal call sdk error in tele flow',
          extras: {
            error: JSON.stringify(payload)
          },
          type: 'info'
        });
        addClickstreamEvent(
          CLICKSTREAM_EVENT_NAMES.LH_UniversalCallSDK_CLICKSTREAM_PROCESSOR,
          payload
        );
      }
    },
    adapterOptions
  });

  const [multiTabDialerDisabled, setMultiTabDialerDisabled] = useState(false);
  const isAgentOnline = useSelector((store: RootState) => store.common.isAgentOnline);
  const isLonghornBlocked =
    useSelector((store: RootState) => store.common.cosmosSyncBlockStatus) ===
    CosmosSyncBlockStatus.BLOCKED;
  const isAgentWithInOperativeHours = useSelector(
    (state: RootState) => state?.common?.userData?.withinOperativeHours
  );

  useEffect(() => {
    const ameyoInitBoardcaseChannel = new BroadcastChannel('ameyoInitBoardcastChannel');
    let ameyoInitialisationTimerid: NodeJS.Timeout | number = 0;

    ameyoInitBoardcaseChannel.postMessage({
      type: BroadcastChannelMessages.ask_for_ameyo_initiation
    });

    ameyoInitBoardcaseChannel.onmessage = event => {
      if (event.data.type === BroadcastChannelMessages.already_initialized) {
        console.log('Adapter Ready');
        clearTimeout(ameyoInitialisationTimerid);
        setMultiTabDialerDisabled(true);
        return;
      }

      if (event.data.type === BroadcastChannelMessages.ask_for_ameyo_initiation) {
        if (window.ameyoInitialized) {
          ameyoInitBoardcaseChannel.postMessage({
            type: BroadcastChannelMessages.already_initialized
          });
        }
      }
    };
    ameyoInitialisationTimerid = setTimeout(() => {
      //BC message not recieved let's initialize it here after 2 sec
      // Skip initialization if user is impersonated AND it's not a Navi agency AND external Ameyo calling is disabled
      authData?.userImpersonated && (!isNaviAgency(authData?.agencyCode) && !isExternalAmeyoCallingEnabled)
        ? noop()
        : initialize();
      sdkHelper.logoOut = logOut;
      console.log('initializing ameyo');
      registerOnAdapterReady(() => {
        setAmeyoLoggedIn();
        window.postMessage({ type: 'onAmeyoStatusChange', data: 'ready' });
        console.log('Adapter Ready');
      });
      registerOnCallIncoming((call: StateType) => {
        console.log('Incoming Call', call);
      });
      registerOnCallConnected((call: StateType) => {
        console.log('Call Connected', call);
      });
      registerOnCallDisconnected((call: StateType) => {
        console.log('Call Disconnected', call);
      });
      registerOnAgentAvailabilityChange((isAvailable: boolean, reason: string) => {
        if (reason === errorenous_break_reason) {
          toast(ameyo_errorenous_message, { type: 'error', autoClose: false });
          logger({
            msg: 'ameyo is errorenous',
            extras: {
              flow: 'TELE',
              email: ameyoUserName || ''
            },
            type: 'info'
          });
        }
        dispatch(setIsAvailable(isAvailable));
        if (isAvailable) {
          addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_USER_AVAILABILITY);
          dispatch(setNotificationBubbleColor(BUBBLE_COLORS.GREEN));
        } else {
          dispatch(setNotificationBubbleColor(BUBBLE_COLORS.ORANGE));
        }
      });
      registerOnForcedLogoutListener(() => {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_FORCED_LOGOUT);
        dispatch(setIsAvailable(false));
        toast('you have been forced logout from ameyo please reload the page', {
          type: 'error',
          autoClose: false
        });
        logger({
          msg: 'ameyo is forced logout',
          extras: {
            flow: 'TELE',
            email: ameyoUserName || ''
          },
          type: 'info'
        });
      });

      registerOnLoginFailedListener(() => {
        addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_AMEYO_LOGIN_FAILED, {
          agentEmail: ameyoUserName
        });
        toast('Unable to login in ameyo please contact your TL once', { type: 'error' });
      });

      window.ameyoInitialized = true;
    }, 2000);
  }, []);

  // ---------------  ***** ---------------------

  // there is a third state called authError, in which the user
  // is expected to do stuff, so although he is still !loggedIn
  // he is also not loggedOut, hence isLoggedOut!=isLoggedIn

  const isLoggedIn = useMemo(() => {
    dispatch(setIsAmeyoErronous(false));
    return (
      AMEYO_STATUS_RANKS[AMEYO_STATUS_CODES.LOGGED_IN].occuranceOrder <=
      AMEYO_STATUS_RANKS[toolbarAuthState].occuranceOrder
    );
  }, [toolbarAuthState]);

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (ameyoExtensionToggleOn && !isAmeyoErronous) {
      if (event.ctrlKey && (event.key === 'm' || event.key === 'M')) {
        handleMuteOngoingCall(AmeyoConstants.AMEYO_SHORTCUT);
      }
    }
  };

  const checkConditionsAndSetVisibilityForMuteDisclaimer = () => {
    if (currentAmeyoState === AmeyoCallState.TALKING && ameyoCallData.mutedAt) {
      dispatch(setIsMuteDisclaimerVisible(true));
    }
  };

  const handleCloseDisclaimer = () => {
    dispatch(setIsMuteDisclaimerVisible(false));
    clearInterval(timerId.current);
    timerId.current = setInterval(checkConditionsAndSetVisibilityForMuteDisclaimer, 5000);
  };

  const handleCloseAmeyoExtensionDisclaimer = () => {
    dispatch(setIsAmeyoExtOffDisclaimerVisible(false));
  };

  const handleCloseAmeyoErroneousDisclaimer = () => {
    dispatch(setShowAmeyoErroneousMsg(false));
  };

  const isLoggedOut = useMemo(() => {
    return (
      AMEYO_STATUS_RANKS[AMEYO_STATUS_CODES.LOGGED_OUT].occuranceOrder >=
      AMEYO_STATUS_RANKS[toolbarAuthState].occuranceOrder
    );
  }, [toolbarAuthState]);

  const createInteractionApi = (additionalParams: {
    phone: string | number;
    loanaccountnumber: string;
    crtObjectId: string;
  }) => {
    const { loanaccountnumber, phone, crtObjectId } = additionalParams;
    const url = getApiUrl(ApiKeys.CREATE_AMEYO_INTERACTION);
    const data: CreateInteractionRequest = {
      accountNumber: loanaccountnumber,
      recipientPhoneNumber: phone,
      callingMode: CALLING_MODES.AUTO_DIALLER,
      interactionType: InteractionType.AMEYO,
      externalCallId: crtObjectId
    };
    console.log('ameyo debugging', 'About to create interaction');
    return axiosInstance.post(url, data).then(resp => {
      console.log('ameyo debugging', 'create interaction response in accept call', resp);
      setInteractionData({
        interactionId: resp?.data?.referenceId,
        recipientNumber: resp?.data?.source.recipientNumber,
        crtObjectId: ameyoCallData?.crtObjectId
      });
      dispatch(
        setAmeyoCallDetails({
          interactionId: resp?.data?.referenceId,
          recipientNumber: resp?.data?.source.recipientNumber,
          crtObjectId: ameyoCallData?.crtObjectId
        })
      );
    });
  };

  const createInteraction = (
    connectedCustomerData: IConnectedCustomer,
    lan: string,
    phone: string,
    crtObjId: string
  ) => {
    try {
      console.log('ameyo debugging', {
        ameyoCallData: { lan, crtObjId, phone },
        connectedCustomerData
      });
      createInteractionApi({
        loanaccountnumber: lan,
        phone: phone + '',
        crtObjectId: crtObjId
      })
        .catch(err => {
          addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_CREATE_INTERACTION_FAILED, {
            lan: lan,
            phoneNumber: phone,
            crtObjectId: crtObjId
          });
          console.log('ameyo debugging', 'error in creating interaction', err);
        })
        .finally(() => {
          addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_CALL_ACCEPTED_SUCCESSFULLY, {
            loanAccountNumber: lan,
            phoneNumber: phone,
            crtObjectId: crtObjId
          });
        });
    } catch (e) {
      toast('Error creating interaction', { type: 'info' });
    }
  };

  const onCallInComingCallback = (phoneNumber: number, lan: string, crtObjectId: string) => {
    console.log('ameyo debugging', 'on incoming callback called');
    dispatch(setCurrentState(AmeyoCallState.RINGING));
    console.log('ameyo debugging', 'setting up ameyo call data', { phoneNumber, lan, crtObjectId });
    setCurrentAmeyoCallDetails({ phoneNumber: phoneNumber + '', lan, crtObjectId });
    fetchAndSetConnectedCustomerData({ lan, phoneNumber: String(phoneNumber) }).catch(err => {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_FETCH_CONNECTED_CUSTOMER_FAILED, {
        phoneNumber,
        lan
      });
      toast('Error fetching connected customer data', { type: 'error' });
    });
  };
  const onCallConnectedCallback = (phoneNumber: number, lan: string, crtObjectId: string) => {
    // update state to connected ,  show disconnect button
    dispatch(setCurrentState(AmeyoCallState.TALKING));
    ExtensionHandler.updateIsPending(true);
  };

  function performAmeyoStateChangeSideEffect(status: AMEYO_STATUS_CODES, availabilty = false) {
    dispatch(setToolbarAuthState(status));
    if (
      AMEYO_STATUS_RANKS[AMEYO_STATUS_CODES.LOGGED_OUT].occuranceOrder >=
      AMEYO_STATUS_RANKS[status].occuranceOrder &&
      ameyoUserName &&
      authData?.ameyoKey
    ) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_SUCCESSFUL_LOGOUT, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus()
      });
    }
    // status is anything [loggedIn, ready)
    if (
      AMEYO_STATUS_RANKS[AMEYO_STATUS_CODES.READY].occuranceOrder >
      AMEYO_STATUS_RANKS[status].occuranceOrder &&
      AMEYO_STATUS_RANKS[AMEYO_STATUS_CODES.LOGGED_IN].occuranceOrder <=
      AMEYO_STATUS_RANKS[status].occuranceOrder
    ) {
      dispatch(setNotificationBubbleColor(BUBBLE_COLORS.PINK));
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_SUCCESSFUL_LOGIN);
    }
    // when ready
    if (status === AMEYO_STATUS_CODES.READY) {
      dispatch(setNotificationBubbleColor(BUBBLE_COLORS.ORANGE));
    }
    if (availabilty) {
      dispatch(setNotificationBubbleColor(BUBBLE_COLORS.GREEN));
    }
    if (authData?.ameyoKey && !ameyoUserName) {
      toast('No email found, cannot login in ameyo.', { type: 'info' });
    }
  }

  function onAmeyoAuthStateChanged(currentState: AMEYO_STATUS_CODES) {
    if (currentState === AMEYO_STATUS_CODES.LOGGED_IN) {
      if (!authError) {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_LOGIN_AUTO_SUCCESSFUL, {
          campaignId,
          ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
          loanAccountNumber: ameyoCallData?.lan,
          phoneNumber: ameyoCallData?.phoneNumber
        });
      }

      authError = false;
    } else if (currentState === AMEYO_STATUS_CODES.AUTH_ERROR) {
      authError = true;
    }

    performAmeyoStateChangeSideEffect(currentState, ExtensionHandler.isAvailable());
  }

  function onAmeyoAvailabiltyChanged(isAvailable: boolean) {
    dispatch(setIsAvailable(isAvailable));
  }

  function onAmeyoCallDataChanged(callData: AmeyoCallData) {
    console.log('ameyo debugging', 'call data changed', callData);
    dispatch(setAmeyoCallData(callData));
    const resetValue = LocalStorage.getItem(LOCAL_STORAGE_KEYS.AMEYO_CALL_RESET_FLAG);
    const isResetAllowed = resetValue ? resetValue === 'true' : false;
    isResetAllowed && resetButtonState();
  }

  function resetButtonState() {
    dispatch(
      setButtonLoadingStates({
        ...buttonLoadingStates,
        acceptButton: false,
        rejectButton: false,
        disconnectButton: false
      })
    );
  }
  const onAmeyoErroneous = () => {
    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_ERRONEOUS, {
      loanAccountNumber: ameyoCallData?.lan,
      phoneNumber: ameyoCallData?.phoneNumber,
      campaignId,
      ameyoStatus: ExtensionHandler.currentAmeyoStatus()
    });

    dispatch(setIsAmeyoErronous(true));
  };

  const onToggleAmeyoStatus = (onToggleAmeyoStatusData: onToggleAmeyoStatusDataProps) => {
    if (onToggleAmeyoStatusData.ameyoToggleNewStatus === AmeyoToggleNewStatus.OFF) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_EXTENSION_TOGGLE_OFF_CLICKED, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber
      });

      dispatch(setAmeyoExtensionToggleOn(false));

      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_EXTENSION_TOGGEL_OFF_SUCCESSFULL, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber
      });
      return;
    }
    if (onToggleAmeyoStatusData.ameyoToggleNewStatus === AmeyoToggleNewStatus.ON) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_EXTENSION_TOGGLE_ON_CLICKED, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber
      });

      dispatch(setAmeyoExtensionToggleOn(true));

      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_EXTENSION_TOGGEL_ON_SUCCESSFULL, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber
      });
      return;
    }
  };

  const agentOnlineHandler = () => {
    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_AVAILABLE_TOGGLE_CLICKED, {
      campaignId,
      ameyoStatus: ExtensionHandler.currentAmeyoStatus()
    });
    if (getAgentAvailability()) {
      setOnBreak();
    } else {
      setAvailable();
    }
  };

  const hangupCall = (type: string) => {
    rejectCallNew();
    newAmeyoResync();
    return;
  };

  const newAmeyoResync = () => {
    if (getLatestCallState() === 'IDLE' || getLatestCallState() === 'CALL_DISCONNECTED') {
      dispatch(resetState());
    }
    return;
  };

  function acceptCall() {
    acceptCallNew();
    newAmeyoResync();
    if (buttonLoadingStates.acceptButton) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_AMEYO_CALL_DISABLED_ACCEPT_CLICKED, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber
      });

      return;
    }

    createInteraction(
      connectedCustomerData,
      currentAmeyoCallDetails?.lan || '',
      currentAmeyoCallDetails?.phoneNumber || '',
      currentAmeyoCallDetails?.crtObjectId || ''
    );
    dispatch(setShouldPlayRingtone(false));
    dispatch(
      setButtonLoadingStates({ ...buttonLoadingStates, acceptButton: true, rejectButton: true })
    );
    console.log('ameyo debugging', 'interaction data', interactionData);
    navigateToCaseDetail();

    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_CALL_ACCEPT_CLICKED, {
      loanAccountNumber: currentAmeyoCallDetails?.lan,
      phoneNumber: currentAmeyoCallDetails?.phoneNumber,
      crtObjectId: currentAmeyoCallDetails?.crtObjectId
    });
    if (isAmeyoErronous) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_ACCEPT_ERROR, {
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber,
        crtObjectId: ameyoCallData?.crtObjectId
      });
    }
  }

  function rejectCall() {
    if (buttonLoadingStates.rejectButton) {
      addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_AMEYO_CALL_DISABLED_REJECT_CLICKED, {
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus(),
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber
      });

      return;
    }

    addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_CALL_REJECT_CLICKED, {
      loanAccountNumber: currentAmeyoCallDetails?.lan,
      phoneNumber: currentAmeyoCallDetails?.phoneNumber,
      crtObjectId: currentAmeyoCallDetails?.crtObjectId
    });
    if (isAmeyoErronous) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_REJECT_ERROR, {
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber,
        crtObjectId: ameyoCallData?.crtObjectId
      });
    }
    rejectCallNew();
  }

  const handleMuteOngoingCall = (type: string) => {
    if (isAmeyoErronous) {
      dispatch(setShowAmeyoErroneousMsg(true));
      if (ameyoCallData?.mutedAt) {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_UNMUTE_ERROR, {
          loanAccountNumber: ameyoCallData?.lan,
          phoneNumber: ameyoCallData?.phoneNumber,
          crtObjectId: ameyoCallData?.crtObjectId
        });
        return;
      }
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_MUTE_ERROR, {
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber,
        crtObjectId: ameyoCallData?.crtObjectId
      });

      return;
    }
    if (!ameyoExtensionToggleOn) {
      dispatch(setIsAmeyoExtOffDisclaimerVisible(true));
      return;
    }
    if (ameyoCallData?.mutedAt) {
      if (type === AmeyoConstants.AMEYO_WIDGET) {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_UNMUTE_WIDGET_CLICKED, {
          loanAccountNumber: ameyoCallData?.lan,
          phoneNumber: ameyoCallData?.phoneNumber,
          crtObjectId: ameyoCallData?.crtObjectId
        });
      }
      if (type === AmeyoConstants.AMEYO_TOOLBAR) {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_UNMUTE_TOOLBAR_CLICKED, {
          loanAccountNumber: ameyoCallData?.lan,
          phoneNumber: ameyoCallData?.phoneNumber,
          crtObjectId: ameyoCallData?.crtObjectId
        });
      }
      unmuteCallNew();
      ExtensionHandler.unMuteCall(() => {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_UNMUTE_SUCCESSFULL, {
          loanAccountNumber: ameyoCallData?.lan,
          phoneNumber: ameyoCallData?.lan,
          crtObjectId: ameyoCallData?.crtObjectId
        });
      });

      return;
    }

    if (type === AmeyoConstants.AMEYO_WIDGET) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_MUTE_WIDGET_CLICKED, {
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber,
        crtObjectId: ameyoCallData?.crtObjectId
      });
    }
    if (type === AmeyoConstants.AMEYO_TOOLBAR) {
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_MUTE_TOOLBAR_CLICKED, {
        loanAccountNumber: ameyoCallData?.lan,
        phoneNumber: ameyoCallData?.phoneNumber,
        campaignId,
        ameyoStatus: ExtensionHandler.currentAmeyoStatus()
      });
    }
    muteCallNew();
  };
  const onAmeyoAcceptError = () => {
    resetButtonState();
  };

  function navigateToCaseDetail() {
    if (!connectedCustomerData?.customerName) {
      toast('Please use LAN search to navigate to this case.', { type: 'info' });
      return;
    }
    const searchParams = createQueryParams({
      AMEYO: { phoneNumber: connectedCustomerData?.phoneNumber || '', method: ECallingType.AMEYO }
    });
    navigateToCaseDetails(
      connectedCustomerData?.customerId || '',
      connectedCustomerData?.lan || '',
      connectedCustomerData?.caseReferenceId || '',
      connectedCustomerData?.businessVertical || '',
      navigate,
      APP_ROUTES.CASE_DETAIL.path,
      searchParams
    );
  }

  function fetchAndSetConnectedCustomerData(params: { lan: string; phoneNumber: string }) {
    const lan = params?.lan || connectedCustomerData.lan;
    const phoneNumber = params?.phoneNumber || connectedCustomerData.phoneNumber;
    let getCustomerReferenceIdPromise = null;
    if (lan && phoneNumber) {
      getCustomerReferenceIdPromise = getCustomerReferenceIdFromLAN(
        lan,
        (loanAccountNumber: string, customerDetails: AllCasesSummary) => {
          if (loanAccountNumber && customerDetails?.customerId) {
            dispatch(
              getCustomerDetails(
                loanAccountNumber,
                customerDetails.customerId,
                customerDetails?.caseReferenceId || '',
                customerDetails?.businessVertical || ''
              )
            );
            dispatch(
              setConnectedCustomerData({
                lan,
                phoneNumber,
                customerId: customerDetails?.customerId,
                customerName: customerDetails?.customerName,
                caseReferenceId: customerDetails?.caseReferenceId,
                businessVertical: customerDetails?.businessVertical
              })
            );
            getTelephones(
              lan,
              '',
              customerDetails?.caseReferenceId || '',
              customerDetails?.businessVertical || '',
              (telephones: ITelePhoneData[]) => {
                const source =
                  telephones?.find(telephone => telephone.number === phoneNumber)?.source || '';
                dispatch(
                  setTelephoneSource(
                    PhoneNumberSources?.[source as keyof typeof PhoneNumberSources] ?? source
                  )
                );
              }
            );
          }
        }
      );
      // checked on BE customerId is not null
      // Also it is not required to check for phoneNumber
    }
    return Promise.all([getCustomerReferenceIdPromise]);
  }

  useOutsideClick(currentRef, () => {
    dispatch(setIsVisible(false));
  });

  const onSendCurrentCallStatus = (data?: IAmeyoRecalibratedData) => {
    if (
      data?.callStatus === AMEYO_CALL_EVENTS.DISCONNECTED ||
      data?.callStatus === AMEYO_CALL_EVENTS.IDLE
    ) {
      dispatch(resetState());
      return;
    } else if (data?.callStatus === AMEYO_CALL_EVENTS.CONNECTED) {
      dispatch(setCurrentState(AmeyoCallState.TALKING));
      if (connectedCustomerData?.lan) {
        return;
      }
      fetchAndSetConnectedCustomerData({ lan: data?.lan, phoneNumber: data?.phoneNumber });
    }
  };

  useEffect(() => {
    isLitmusExperimentEnabled(LITMUS_EXPERIMENT_NAMES.COLLECTION_AMEYO_FIX, {
      'x-customer-id': authData?.referenceId
    }).then(res => {
      LocalStorage.setItem(LOCAL_STORAGE_KEYS.AMEYO_CALL_RESET_FLAG, res?.result);
    });
  }, []);

  useEffect(() => {
    dispatch(setAmeyoCallData(ExtensionHandler.currentCallStatus()));
    dispatch(setIsAvailable(ExtensionHandler.isAvailable()));
  }, []);

  useEffect(() => {
    performAmeyoStateChangeSideEffect(
      ExtensionHandler.currentAmeyoStatus(),
      ExtensionHandler.isAvailable()
    );
  }, [authData]);

  useEffect(() => {
    if (
      currentAmeyoState === AmeyoCallState.TALKING &&
      ameyoExtensionToggleOn &&
      !isAmeyoErronous
    ) {
      const onKeyDown = (event: any) => handleKeyPress(event);
      document.addEventListener('keydown', onKeyDown);

      return () => {
        document.removeEventListener('keydown', onKeyDown);
      };
    }
  }, [currentAmeyoState, ameyoCallData, ameyoExtensionToggleOn, isAmeyoErronous]);

  useEffect(() => {
    checkConditionsAndSetVisibilityForMuteDisclaimer();
    timerId.current = setInterval(
      checkConditionsAndSetVisibilityForMuteDisclaimer,
      AMEYO_MUTE_DISCLAIMER_INTERVAL
    );

    return () => {
      clearInterval(timerId.current);
    };
  }, [ameyoCallData]);

  useEffect(() => {
    if (currentAmeyoState === AmeyoCallState.TALKING && !isVisible) {
      if (!ameyoExtensionToggleOn && !isAmeyoErronous) {
        dispatch(setIsAmeyoExtOffDisclaimerVisible(true));
        return;
      }

      dispatch(setIsAmeyoExtOffDisclaimerVisible(false));
    }
  }, [ameyoExtensionToggleOn, isAmeyoErronous]);

  useEffect(() => {
    if (currentAmeyoState === AmeyoCallState.TALKING && !isVisible) {
      if (isAmeyoErronous) {
        dispatch(setShowAmeyoErroneousMsg(true));
        return;
      }
      dispatch(setShowAmeyoErroneousMsg(false));
    }
  }, [isAmeyoErronous]);

  useEffect(() => {
    /**
     * this would be the case if someone opens the new tab while he is on call
     */
    if (currentAmeyoState === AmeyoCallState.TALKING && !connectedCustomerData?.customerName) {
      fetchAndSetConnectedCustomerData({
        lan: connectedCustomerData.lan,
        phoneNumber: connectedCustomerData.phoneNumber
      });
    }
    resetButtonState();
  }, [currentAmeyoState]);
  useEffect(() => {
    if (
      currentAmeyoState === AmeyoCallState.RINGING ||
      currentAmeyoState === AmeyoCallState.TALKING
    ) {
      window.addEventListener('beforeunload', handleTabClose);
      props.isCallHappening(true);
    }
    if (
      currentAmeyoState !== AmeyoCallState.RINGING &&
      currentAmeyoState !== AmeyoCallState.TALKING
    ) {
      props.isCallHappening(false);
    }
    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, [currentAmeyoState]);

  useEffect(() => {
    if (
      buttonLoadingStates.disconnectButton ||
      buttonLoadingStates.rejectButton ||
      buttonLoadingStates.acceptButton
    ) {
      setTimeout(resetButtonState, BUTTON_ENABLED_TIMEOUT);
    }
  }, [buttonLoadingStates]);

  useEffect(() => {
    if (currentAmeyoState === AmeyoCallState.RINGING) {
      dispatch(setIsVisible(true));
      dispatch(setShouldPlayRingtone(true));
      fetchAndSetConnectedCustomerData({
        lan: connectedCustomerData.lan,
        phoneNumber: connectedCustomerData.phoneNumber
      });
      addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_RINGING, {
        ringingAt: ameyoCallData?.ringingAt,
        acceptedAt: ameyoCallData?.acceptedAt,
        disconnectedAt: ameyoCallData?.disconnectedAt,
        mutedAt: ameyoCallData?.mutedAt,
        unMutedAt: ameyoCallData?.unMutedAt,
        phoneNumber: currentAmeyoCallDetails?.phoneNumber,
        lan: currentAmeyoCallDetails?.lan,
        crtObjectId: currentAmeyoCallDetails?.crtObjectId
      });
    }
  }, [currentAmeyoState]);

  useEffect(() => {
    if (
      !(
        currentAmeyoState === AmeyoCallState.TALKING || currentAmeyoState === AmeyoCallState.RINGING
      )
    ) {
      dispatch(
        setConnectedCustomerData({ phoneNumber: '', lan: '', customerId: '', customerName: '' })
      );
      dispatch(setTelephoneSource(''));
    }
  }, [currentAmeyoState]);

  useEffect(() => {
    const link = document.createElement('link');
    link.type = 'image/svg+xml';
    link.rel = 'icon';

    const svgString = jsxToString(ameyoCallData.mutedAt ? <MicOff /> : <NaviTabIcon />);
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml' });

    link.href = URL.createObjectURL(svgBlob);

    const existingFavicon = document.querySelector('link[rel="icon"]');

    if (existingFavicon) {
      document.head.removeChild(existingFavicon);
    }

    document.head.appendChild(link);

    return () => {
      URL.revokeObjectURL(link.href);
      document.head.removeChild(link);
    };
  }, [ameyoCallData]);

  useEffect(() => {
    if (toolbarAuthState === AMEYO_STATUS_CODES.AUTH_ERROR) {
      dispatch(setIsVisible(true));
    }
  }, [toolbarAuthState, isLoggedIn]);

  // useEffect(() => {
  //   performAmeyoStateChangeSideEffect(ExtensionHandler.currentAmeyoStatus(), isAmeyoAvailable);
  // }, [isAmeyoAvailable]);

  useEffect(() => {
    const checkAvailabilityAndCallEvent = () => {
      if (isAmeyoAvailable) {
        addClickstreamEvent(AMEYO_SESSION_EVENTS.LH_AMEYO_USER_AVAILABILITY);
      }
    };

    checkAvailabilityAndCallEvent();

    const intervalId = setInterval(checkAvailabilityAndCallEvent, 30000);

    return () => clearInterval(intervalId);
  }, []);

  const onCallDisConnectedCallback = (phoneNumber: number, lan: string, crtObjectId: string) => {
    dispatch(setCurrentState(AmeyoCallState.IDLE));
  };
  const isTalkingOrRinging = useMemo(
    () =>
      currentAmeyoState === AmeyoCallState.RINGING || currentAmeyoState === AmeyoCallState.TALKING,
    [currentAmeyoState]
  );
  const showExtensionDisabledMessage =
    currentAmeyoState === AmeyoCallState.TALKING &&
    isAmeyoExtOffDisclaimerVisible &&
    !isAmeyoErronous &&
    !isVisible;
  const showOngoingMutedCallDisclaimer =
    currentAmeyoState === AmeyoCallState.TALKING &&
    ameyoCallData.mutedAt &&
    ameyoExtensionToggleOn &&
    !isAmeyoExtOffDisclaimerVisible &&
    !showAmeyoErroneousMsg &&
    !isAmeyoErronous &&
    !isVisible;
  const bottomValue =
    currentAmeyoState === AmeyoCallState.TALKING && (!ameyoExtensionToggleOn || isAmeyoErronous)
      ? -68
      : toolbarAuthState === AMEYO_STATUS_CODES.READY
        ? -57
        : 2;

  useEffect(() => {
    ExtensionHelper.addExtensionListener(EXTENSION_LISTENER_TYPES.ameyoErroneous, onAmeyoErroneous);
    ExtensionHelper.addExtensionListener(
      EXTENSION_LISTENER_TYPES.onCallInComing,
      onCallInComingCallback
    );
    ExtensionHelper.addExtensionListener(
      EXTENSION_LISTENER_TYPES.onCallConnected,
      onCallConnectedCallback
    );
    ExtensionHelper.addExtensionListener(
      EXTENSION_LISTENER_TYPES.onCallDisConnected,
      onCallDisConnectedCallback
    );
  }, []);

  useEffect(() => {
    ExtensionHelper.addExtensionListener(
      EXTENSION_LISTENER_TYPES.toggleAmeyoStatus,
      onToggleAmeyoStatus
    );
  }, []);

  useEffect(() => {
    isLitmusExperimentEnabled(LITMUS_EXPERIMENT_NAMES.COLLECTION_AMEYO_CALL_COUNT_POLLING, {
      'x-customer-id': authData?.referenceId
    }).then(res => {
      if (res?.result) {
        setCallCountEnabled(true);
        if (isVisible) {
          ameyoCallsCountIntervalRef.current = poll(
            () => {
              dispatch(
                getCallBridgeData({ includeAmeyoCallCount: true, includeCallBridgeCount: false })
              );
            },
            undefined,
            AMEYO_CALL_COUNT_POLLING_INTERVAL,
            noop
          );
        } else {
          isFunction(ameyoCallsCountIntervalRef.current) && ameyoCallsCountIntervalRef.current();
        }
      } else {
        setCallCountEnabled(false);
      }
    });
    return () => {
      isFunction(ameyoCallsCountIntervalRef.current) && ameyoCallsCountIntervalRef.current();
    };
  }, [isVisible]);

  return (
    <div className={styles.container} ref={currentRef}>
      <div className={styles.sideToolbarAmeyoIconsWrapper}>
        {
          <div
            className={cx(
              {
                [styles.displayNone]: !(currentAmeyoState === AmeyoCallState.TALKING && !isVisible)
              },
              styles.sliderSmoother,
              styles.grayBckground
            )}
          >
            <Tooltip placement="top">
              <TooltipTrigger>
                <div
                  onClick={() => handleMuteOngoingCall(AmeyoConstants.AMEYO_TOOLBAR)}
                  className={
                    ameyoExtensionToggleOn && !isAmeyoErronous
                      ? styles.muteUnmuteToolTipWrapper
                      : styles.disabledUnmuteToolTipWrapper
                  }
                >
                  {ameyoCallData?.mutedAt ? <UnMuteCircledIcon /> : <MuteCircledIcon />}
                </div>
              </TooltipTrigger>
              {ameyoExtensionToggleOn && !isAmeyoErronous && (
                <TooltipContent className={styles.muteOptionTooltip}>
                  {ameyoCallData?.mutedAt
                    ? AmeyoConstants.UNMUTE_ONGOING_CALL_TOOLTIP
                    : AmeyoConstants.MUTE_ONGOING_CALL_TOOLTIP}
                </TooltipContent>
              )}
            </Tooltip>
            <Tooltip placement="right">
              <TooltipTrigger>
                <div
                  onClick={() => hangupCall(AmeyoConstants.AMEYO_TOOLBAR)}
                  className={
                    ameyoExtensionToggleOn && !isAmeyoErronous
                      ? styles.diconnectBtnWrapper
                      : styles.disabledDiconnectBtnWrapper
                  }
                >
                  <HangUpCallIcon />
                </div>
              </TooltipTrigger>
              {ameyoExtensionToggleOn && !isAmeyoErronous && (
                <TooltipContent className={styles.muteOptionTooltip}>
                  {AmeyoConstants.DISCONNECT_ONGOING_AMEYO_CALL}
                </TooltipContent>
              )}
            </Tooltip>
          </div>
        }
        <div
          onClick={() => {
            dispatch(setIsVisible(!isVisible));
          }}
          className={styles.toolbarWrapper}
        >
          <AmeyoIcon />
          <div
            style={{
              display: isTalkingOrRinging ? 'block' : 'none'
            }}
            className={styles.iconWrapper}
          >
            <RssIcon />
          </div>
        </div>
        {isLoggedIn ? (
          <div
            style={{
              background: notificationBubbleColor
            }}
            className={cx(
              {
                [styles.topPadder]: currentAmeyoState === AmeyoCallState.TALKING && !isVisible
              },
              styles.bubble
            )}
          ></div>
        ) : toolbarAuthState === AMEYO_STATUS_CODES.AUTH_ERROR ? (
          <div className={styles.bubbleAttemptFailed}>
            <p className={styles.attemptFailedLoginExclaim}>!</p>
          </div>
        ) : (
          <div className={styles.bubbleAttempt}>
            <CyclicArrow />
          </div>
        )}
      </div>
      <Typography variant="h6" color={'white'} className={styles.titleWrapper}>
        Ameyo
      </Typography>
      {currentAmeyoState === AmeyoCallState.TALKING && showAmeyoErroneousMsg && !isVisible && (
        <div
          style={{
            display: showAmeyoErroneousMsg ? 'flex' : 'none',
            bottom: 68
          }}
          className={styles.ameyoExtTurnOffDisclaimer}
        >
          <span>{AmeyoConstants.AMEYO_ERRONEOUS_MSG}</span>
          <span
            onClick={() => {
              handleCloseAmeyoErroneousDisclaimer();
            }}
          >
            <CloseIcon />
          </span>
        </div>
      )}
      {showExtensionDisabledMessage && (
        <div
          style={{
            display: isAmeyoExtOffDisclaimerVisible ? 'flex' : 'none',
            bottom: 68
          }}
          className={styles.ameyoExtTurnOffDisclaimer}
        >
          <span>{AmeyoConstants.AMEYO_EXTENSION_DISABLED_MSG}</span>
          <span
            onClick={() => {
              handleCloseAmeyoExtensionDisclaimer();
            }}
          >
            <CloseIcon />
          </span>
        </div>
      )}
      {showOngoingMutedCallDisclaimer && (
        <div
          style={{
            display: isMuteDisclaimerVisible ? 'flex' : 'none',
            bottom: 74
          }}
          className={styles.ongoingMutedDisclaimer}
        >
          <span>{AmeyoConstants.ONGOING_MUTED_CALL_DICLAIMER}</span>
          <span
            onClick={() => {
              handleCloseDisclaimer();
            }}
          >
            <CloseIcon />
          </span>
        </div>
      )}
      <div
        style={{
          display: isVisible ? 'block' : 'none',
          bottom: multiTabDialerDisabled ? 0 : bottomValue
        }}
        className={cx(
          {
            [styles.leftPaddingContainer]: currentAmeyoState === AmeyoCallState.TALKING
          },
          styles.popupContainer
        )}
      >
        {multiTabDialerDisabled ? (
          <div className={styles.dialerDisabled}>
            <p className={styles.popupText}>
              Dialer is disabled since ameyo is active on another tab
            </p>
            <span
              onClick={() => {
                dispatch(setIsVisible(false));
              }}
              className={styles.paddedSpan}
            >
              <CloseIcon />
            </span>
          </div>
        ) : null}
        {isLoggedIn && !multiTabDialerDisabled ? (
          <>
            {toolbarAuthState === AMEYO_STATUS_CODES.READY ? (
              <div
                className={
                  currentAmeyoState === AmeyoCallState.TALKING &&
                    (!ameyoExtensionToggleOn || isAmeyoErronous)
                    ? styles.ameyoPopupExtraHeight
                    : styles.ameyoPopup
                }
              >
                <span className={styles.header}>
                  {toolbarAuthState === AMEYO_STATUS_CODES.READY && !isTalkingOrRinging ? (
                    <Switch
                      variant="secondary"
                      checked={isAmeyoAvailable}
                      onChange={agentOnlineHandler}
                      disabled={!isAgentOnline || isLonghornBlocked || !isAgentWithInOperativeHours}
                    />
                  ) : (
                    <Typography
                      variant="h6"
                      color={'var(--grayscale-2)'}
                      className={cx(styles.waitReady, styles.textAlignCenter)}
                    >
                      <span className={styles.activeText}>
                        <b>{connectedCustomerData?.phoneNumber}</b>{' '}
                        {telephoneSource ? telephoneSource : ''}
                      </span>
                    </Typography>
                  )}
                  <div className={styles.muteIconWraper}>
                    {currentAmeyoState === AmeyoCallState.TALKING && (
                      <Tooltip>
                        <TooltipTrigger>
                          <span
                            onClick={() => handleMuteOngoingCall(AmeyoConstants.AMEYO_WIDGET)}
                            className={
                              ameyoExtensionToggleOn && !isAmeyoErronous
                                ? ''
                                : styles.disabledMuteIconWraper
                            }
                          >
                            {ameyoCallData?.mutedAt ? <UnMuteIcon /> : <MuteIcon />}
                          </span>
                        </TooltipTrigger>
                        {ameyoExtensionToggleOn && !isAmeyoErronous && (
                          <TooltipContent className={styles.muteOptionTooltip}>
                            {ameyoCallData?.mutedAt
                              ? AmeyoConstants.UNMUTE_ONGOING_CALL_TOOLTIP
                              : AmeyoConstants.MUTE_ONGOING_CALL_TOOLTIP}
                          </TooltipContent>
                        )}
                      </Tooltip>
                    )}
                    <span
                      onClick={() => {
                        dispatch(setIsVisible(false));
                        ExtensionHandler.getCurrentCallStatus();
                      }}
                      className={styles.paddedSpan}
                    >
                      <CloseIcon />
                    </span>
                  </div>
                </span>
                <div className={styles.activePopupContent}>
                  {currentAmeyoState === AmeyoCallState.RINGING ? (
                    <div className={styles.contentContainer}>
                      <Typography
                        variant="h6"
                        color={'var(--grayscale-2)'}
                        className={cx(styles.waitReady, styles.textAlignCenter)}
                      >
                        <span className={styles.headerText}>
                          <span
                            className={styles.connectCustomerName}
                            onClick={navigateToCaseDetail}
                          >
                            {connectedCustomerData?.customerName || 'A Customer'}
                          </span>{' '}
                          is on the call. <br />
                        </span>
                        <span className={styles.activeText}>
                          LAN : <b>{ameyoCallData?.lan}</b>
                        </span>
                      </Typography>
                      <div className={styles.callActionButtonContainer}>
                        <div
                          className={cx(styles.acceptButton, {
                            [styles.buttonDisabled]: buttonLoadingStates.acceptButton
                          })}
                          onClick={acceptCall}
                        >
                          <span>Accept</span>
                        </div>
                        <div
                          className={cx(styles.rejectButton, {
                            [styles.buttonDisabled]: buttonLoadingStates.rejectButton
                          })}
                          onClick={rejectCall}
                        >
                          <span>Reject</span>
                        </div>
                      </div>
                    </div>
                  ) : currentAmeyoState === AmeyoCallState.TALKING ? (
                    <div className={styles.contentContainer}>
                      <Typography
                        variant="h6"
                        color={'var(--grayscale-2)'}
                        className={cx(styles.waitReady, styles.textAlignCenter)}
                      >
                        <span className={styles.headerText}>
                          <span
                            className={styles.connectCustomerName}
                            onClick={navigateToCaseDetail}
                          >
                            {connectedCustomerData?.customerName || 'A Customer'}
                          </span>{' '}
                          is on the call. <br />
                        </span>
                        <span className={styles.activeText}>
                          LAN : <b>{ameyoCallData?.lan}</b>
                        </span>
                      </Typography>
                      <div className={styles.callActionButtonContainer}>
                        <div
                          className={cx(styles.rejectButton, {
                            [styles.buttonDisabled]:
                              buttonLoadingStates.disconnectButton ||
                              !ameyoExtensionToggleOn ||
                              isAmeyoErronous
                          })}
                          onClick={() => hangupCall(AmeyoConstants.AMEYO_WIDGET)}
                        >
                          <span>Disconnect</span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={styles.contentContainer}>
                      {callCountEnabled && (
                        <KeyValueLabel
                          className={styles.ameyoSuccessfullCallCountContainer}
                          dataArray={[
                            {
                              key: 'Ameyo calls attempted today',
                              value: `${ameyoConnectedCallCount}`
                            }
                          ]}
                        />
                      )}
                      <Typography
                        variant="h6"
                        color={'var(--grayscale-2)'}
                        className={cx(styles.waitReady, styles.textAlignJustify)}
                      >
                        {isAmeyoAvailable ? (
                          <span className={styles.activeText}>
                            Please wait while we connect you with a customer...
                          </span>
                        ) : (
                          <span className={styles.activeText}>
                            Please <b>Mark yourself as Available</b> using the toggle above to start
                            receiving calls
                          </span>
                        )}
                      </Typography>
                    </div>
                  )}
                </div>
                {currentAmeyoState === AmeyoCallState.TALKING &&
                  (!ameyoExtensionToggleOn || isAmeyoErronous) && (
                    <div className={styles.disabledExtensionTxt}>
                      <ErrorIcon />
                      <div className={styles.disabledExtensionErrorTxt}>
                        {isAmeyoErronous
                          ? AmeyoConstants.AMEYO_ERRONEOUS_MSG
                          : AmeyoConstants.AMEYO_EXTENSION_DISABLED_MSG}
                      </div>
                    </div>
                  )}
              </div>
            ) : (
              <GridRow className={cx(styles.waitReady, 'items-start')}>
                <GridColumn md={9} className={cx(styles.zeroPadding)}>
                  <Typography
                    variant="h6"
                    color={'var(--grayscale-2)'}
                    className={styles.popupText}
                  >
                    Please wait... Ameyo is loading
                  </Typography>
                </GridColumn>
                <GridColumn className={styles.paddedSpan} md={3}>
                  <span
                    onClick={() => {
                      dispatch(setIsVisible(false));
                      ExtensionHandler.getCurrentCallStatus();
                    }}
                  >
                    <CloseIcon />
                  </span>
                </GridColumn>
              </GridRow>
            )}
          </>
        ) : authData?.userImpersonated ? (
          <div className={styles.dialerDisabled}>
            <p className={styles.popupText}>Dialer is disabled.</p>
            <span
              onClick={() => {
                dispatch(setIsVisible(false));
                ExtensionHandler.getCurrentCallStatus();
              }}
              className={styles.paddedSpan}
            >
              <CloseIcon />
            </span>
          </div>
        ) : isLoggedOut ? (
          <div className={styles.attemptLogin}>
            <p className={styles.popupText}>We are trying to log you into Ameyo...</p>
            <span
              onClick={() => {
                dispatch(setIsVisible(false));
                ExtensionHandler.getCurrentCallStatus();
              }}
              className={styles.paddedSpan}
            >
              <CloseIcon />
            </span>
          </div>
        ) : toolbarAuthState === AMEYO_STATUS_CODES.AUTH_ERROR ? (
          <div className={styles.attemptLogin}>
            <p className={styles.loginMessage}>
              An error occurred.
              <br />
              <span
                onClick={() => {
                  ExtensionHandler.focusAmeyoTab();
                }}
                className={styles.goToAmeyoCTA}
              >
                Go to Ameyo
              </span>{' '}
              to login .
            </p>
            <span
              onClick={() => {
                dispatch(setIsVisible(false));
              }}
              className={styles.paddedSpan}
            >
              <CloseIcon />
            </span>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
